import { useQuery } from 'react-query'
import { get } from '../api'
import { CountryList } from '../types/countries'

// Bad fitting on frontend, to understand why it is happening
const excludedCountries = [
  'China',
  'Antigua and Barbuda',
  'Australia',
  'Bhutan',
  'Central African Republic',
  'Dominica',
  'Grenada',
  'High income',
  'International',
  'Jordan',
  'Kiribati',
  'Kuwait',
  'Lebanon',
  'Liberia',
  'Lithuania',
  'Low income',
  'Lower middle income',
  'Marshall Islands',
  'Micronesia (country)',
  'Oceania',
  'Palau',
  // 'Russia', // processar hoje
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Solomon Islands',
  // 'South Korea', // processar hoje
  'Sudan',
  'Summer Olympics 2020',
  // 'Suriname', // processar hoje
  // 'Sweden', // processar hoje
  // 'Taiwan', // processar hoje
  // 'Thailand', // processar hoje
  'Timor',
  'Tonga',
  'Upper middle income',
  'Vanuatu',
  'Vatican',
  'Vietnam', // processar hoje
  // 'Yemen', // processar hoje
  'Zambia', // processar hoje
]

export const useCountries = () => {
  return useQuery('countries', async () => {
    const countries = await get<{ data: CountryList }>('/countries')
    return countries?.data?.data?.countries?.filter(
      (country) => !excludedCountries.includes(country)
    )
  })
}
